export default "__VITE_ASSET__DHgCGEgn__"